import type { OperatorFunction } from 'rxjs';
import { pipe } from 'rxjs';
import { map } from 'rxjs/operators';

import type { ReportDashboardComponent, ReportResults } from '@core/reports-types';

export const stripValueMetadata: OperatorFunction<
  [ReportDashboardComponent, ReportResults],
  [ReportDashboardComponent, ReportResults]
> = pipe(
  map(([component, data]) => [
    component,
    {
      checksum: data.checksum,
      meta: data.meta,
      results: {
        rows: data.results.rows.map(row => ({
          id: row.id,
          name: row.name,
          values: row.values.filter(value => !Array.isArray(value)),
        })),
        columns: data.results.columns,
      },
    },
  ]),
);
